import {myrequest,myrequest_nt} from 'network/myrequest.js'

//mods seek
function getmods(opt){
  return myrequest({
    url:'/mods/getmods',
    method:"POST",
    data:opt
  })
}
export function d_getmods(opt,cb){
  // $store.state[seekname+'sucais'] = []
  getmods(opt).then(res=>{
    // console.log(res);
    res && cb(res)
  })
}
//mats seek
function getmats(opt){
  return myrequest({
    url:'/mats/getmats',
    method:"POST",
    data:opt
  })
}
export function d_getmats(opt,cb){
  // $store.state[seekname+'sucais'] = []
  getmats(opt).then(res=>{
    // console.log(res);
    res && cb(res)
  })
}

//maps seek
function getmaps(opt){
  return myrequest({
    url:'/maps/getmaps',
    method:"POST",
    data:opt
  })
}
export function d_getmaps(opt,cb){
  // $store.state[seekname+'sucais'] = []
  getmaps(opt).then(res=>{
    // console.log(res);
    res && cb(res)
  })
}

//获取appid
export function getappid(){
  return myrequest_nt({
    url:'/getaid',
    method:"POST"
  })
}

// const options = {}
// Object.assign(options, opt);
// console.log(opt);